import { render, staticRenderFns } from "./model_29.vue?vue&type=template&id=547f7c13&scoped=true"
import script from "./model_29.vue?vue&type=script&lang=js"
export * from "./model_29.vue?vue&type=script&lang=js"
import style0 from "./model_29.vue?vue&type=style&index=0&id=547f7c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547f7c13",
  null
  
)

export default component.exports